<template>
	<div class="image-content">
		<template v-if="multiple">
			<div v-for="(item, index) in file" class="imageBtn"
				:style="{ width: `${width || size}px`, height: `${height || size}px` }" :key="index">
				<el-image style="width: 100%; height: 100%" :initial-index="index" :preview-src-list="file" :src="item"
					fit="cover" loading="lazy"></el-image>
				<div class="delete-icon">
					<span class="del" @click.stop="deleteIcon(index)"><el-icon><el-icon-delete /></el-icon></span>
				</div>
			</div>
			<template v-if="file.length < max">
				<div class="uploadBtn" :style="{ width: `${width || size}px`, height: `${height || size}px` }"
					@click="show">
					<slot name="upload">
						<el-icon>
							<el-icon-plus />
						</el-icon>
					</slot>
				</div>
			</template>
		</template>
		<template v-else>
			<div v-if="file" class="imageBtn"
				:style="{ margin: 0, width: `${width || size}px`, height: `${height || size}px` }">
				<el-image style="width: 100%; height: 100%" :src="file" :preview-src-list="[file]" fit="cover"
					loading="lazy"></el-image>
				<div class="delete-icon">
					<span class="del" @click.stop="deleteImage"><el-icon><el-icon-delete /></el-icon></span>
				</div>
			</div>
			<div v-else class="uploadBtn" :style="{ margin: 0, width: `${width || size}px`, height: `${height || size}px` }"
				@click="show">
				<slot name="upload">
					<el-icon>
						<el-icon-plus />
					</el-icon>
				</slot>
			</div>
		</template>
	</div>
	<scImageSelect v-if="visiable" :max="max" :multiple="multiple" ref="imageSelectRef" @success="handleSuccess"
		@closed="visiable = false">
	</scImageSelect>
</template>

<script>
import scImageSelect from "@/components/scImageSelect";
export default {
	components: {
		scImageSelect,
	},
	props: {
		modelValue: {
			type: [String, Array],
			default: "",
		},
		multiple: { type: Boolean, default: false },
		max: {
			type: Number,
			default: 10,
		},
		size: {
			type: Number,
			default: 60,
		},
		width: {
			type: Number,
			default: 0,
		},
		height: {
			type: Number,
			default: 0,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			visiable: false,
			file: [],
		};
	},
	watch: {
		modelValue: {
			handler(val) {
				this.file = val;
			},
			immediate: true,
			deep: true,
		},
		file(val) {
			this.$emit("update:modelValue", val);
		},
	},
	methods: {
		handleSuccess(img) {
			if (Array.isArray(img) && img.length > 0) {
				let temp = this.max - this.file.length;
				if (temp <= 0) return;
				this.file = this.file.concat(img.slice(0, temp));
			} else {
				this.file = img;
			}
		},
		show() {
			if (this.disabled) return false;
			this.visiable = true;
			this.$nextTick(() => {
				this.$refs.imageSelectRef.open();
			});
		},
		deleteIcon(index) {
			this.file.splice(index, 1);
		},
		deleteImage() {
			this.file = "";
		},
	},
};
</script>

<style lang="scss" scoped>
.image-content {
	width: 100%;
	display: flex;
	flex-wrap: wrap;
	align-items: flex-start;
}

.imageBtn {
	width: 60px;
	height: 60px;
	border: 1px dotted #0000001a;
	margin-right: 15px;
	margin-bottom: 10px;
	display: inline-block;
	position: relative;
	cursor: pointer;
	user-select: none;

	&:hover .delete-icon {
		display: block;
	}

	.delete-icon {
		display: none;
		position: absolute;
		z-index: 1;
		right: 0;
		top: 0;

		span {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 25px;
			height: 25px;
			cursor: pointer;
			color: #fff;
		}

		span i {
			font-size: 12px;
		}

		.del {
			background: #f56c6c;
		}
	}
}

.uploadBtn {
	width: 60px;
	height: 60px;
	line-height: 60px;
	border: 1px dotted #0000001a;
	border-radius: 4px;
	margin-right: 15px;
	margin-bottom: 10px;
	background: #00000005;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>
